module.exports = __webpack_public_path__ + "img/logo2.846ee189.png";